@switch (layout) {
  <!-- Alternativerly use the main layout as the default switch case -->
  @case (layouts.simple) {
    <app-simple-layout></app-simple-layout>
  }
  @case (layouts.main) {
    <app-main-layout></app-main-layout>
  }
}

<!-- Zgoda na ciasteczka Google - poza przełącznikiem układów, więc pyta
     niezależnie od tego, na jaką stronę trafił gość -->
<app-cookie-consent></app-cookie-consent>
